import { render, staticRenderFns } from "./PromotionCode.vue?vue&type=template&id=0c700df9&scoped=true"
import script from "./PromotionCode.vue?vue&type=script&lang=ts"
export * from "./PromotionCode.vue?vue&type=script&lang=ts"
import style0 from "./PromotionCode.vue?vue&type=style&index=0&id=0c700df9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c700df9",
  null
  
)

export default component.exports